import { render, staticRenderFns } from "./faq_page.vue?vue&type=template&id=3e7e7329&scoped=true"
import script from "./faq_page.vue?vue&type=script&setup=true&lang=js"
export * from "./faq_page.vue?vue&type=script&setup=true&lang=js"
import style0 from "./faq_page.vue?vue&type=style&index=0&id=3e7e7329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e7329",
  null
  
)

export default component.exports